import axios from 'axios';

// Service centralisé pour l'intégration Zoho (Inventory, CRM, Books...)
// Utilise les APIs via backend avec tokens stockés

// **PRODUCTS & INVENTORY**

// Récupérer la liste des produits via backend
export async function getProducts() {
  const response = await axios.get('/api/zoho/products');
  // Nouvelle structure de réponse avec cache info
  if (response.data.success && response.data.products) {
    return response.data.products;
  }
  // Fallback pour ancienne structure
  return response.data;
}

// Récupérer les détails complets d'un produit incluant les informations de stock par location
export async function getProductDetails(itemId) {
  const response = await axios.get(`/api/zoho/products/${itemId}`);
  return response.data;
}

// Récupérer en masse les détails/locations de plusieurs produits
export async function getProductsDetails(itemIds) {
  const response = await axios.post('/api/zoho/products/details', { itemIds });
  return response.data;
}


// Récupérer les catégories de produits via backend
export async function getCategories() {
  const response = await axios.get('/api/zoho/categories');
  return response.data;
}

// Mettre à jour le MOQ d'un produit
export async function updateProductMOQ(itemId, moqValue) {
  const response = await axios.put(`/api/zoho/products/${itemId}/moq`, { 
    cf_moq: moqValue 
  });
  return response.data;
}

// Mettre à jour le statut "In Production" d'un produit
export async function updateProductionStatus(itemId, inProduction) {
  const response = await axios.put(`/api/zoho/products/${itemId}/production`, { 
    inProduction: inProduction 
  });
  return response.data;
}

// Mettre à jour le statut favori d'un produit
export async function updateProductFavorite(itemId, isFavorite) {
  const response = await axios.put(`/api/zoho/products/${itemId}/favorite`, { 
    cf_favorite: isFavorite 
  });
  return response.data;
}

// Mettre à jour la visibilité d'un produit (Admin)
export async function updateItemVisibility(itemId, isVisible) {
  const response = await axios.post('/api/zoho/admin/items/visibility', { 
    itemId, 
    isVisible 
  });
  return response.data;
}

// **CONTACTS (CUSTOMERS & VENDORS)**

// Lister les contacts (avec filtre optionnel par type)
export async function getContacts(params = {}) {
  const response = await axios.get('/api/zoho/contacts', { params });
  // Nouvelle structure de réponse avec cache info
  if (response.data.success && response.data.contacts) {
    return response.data.contacts;
  }
  // Fallback pour ancienne structure
  return response.data;
}

// Lister les clients via backend
export async function getCustomers() {
  return getContacts({ contact_type: 'customer' });
}

// Lister les fournisseurs via backend
export async function getVendors() {
  return getContacts({ contact_type: 'vendor' });
}

// Créer un contact via backend
export async function createContact(contactData) {
  const response = await axios.post('/api/zoho/contacts', contactData);
  return response.data;
}

// Créer un client via backend
export async function createCustomer(customerData) {
  return createContact({ ...customerData, contact_type: 'customer' });
}

// Supprimer un contact
export async function deleteContact(contactId) {
  const response = await axios.delete(`/api/zoho/contacts/${contactId}`);
  return response.data;
}

// Supprimer un client (contact)
export async function deleteCustomer(contactId) {
  return deleteContact(contactId);
}

// **PURCHASE ORDERS**

// Créer une commande fournisseur
export async function createPurchaseOrder(purchaseOrderData) {
  const response = await axios.post('/api/zoho/purchase-orders', purchaseOrderData);
  return response.data;
}

// Lister les commandes fournisseurs
export async function getPurchaseOrders() {
  const response = await axios.get('/api/zoho/purchase-orders');
  return response.data;
}

// **ESTIMATES/QUOTATIONS (ZOHO BOOKS)**

// Lister les devis (estimates) via backend
export async function getQuotations() {
  const response = await axios.get('/api/zoho/estimates');
  return response.data;
}

// Créer un devis via backend
export async function createQuotation(quotationData) {
  const response = await axios.post('/api/zoho/estimates', quotationData);
  return response.data;
}
